module.exports = __webpack_public_path__ + "img/assbandf-banner-small.1c8dd21f.jpg";